module.exports = __webpack_public_path__ + "assets/images/project/jem/desktop.svg?v=e4d591b4";